module.exports = __webpack_public_path__ + "static/media/1POLICY8.044003a2.jpg";